/** @format */

const formatDecimal = (num, maxPoints = 0) => {
	let numCast = Number(num);

	return numCast
		.toLocaleString(undefined, {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
		})
		.replaceAll(",", ".");
};

export default formatDecimal;